<template style="">
  <div class="min-h-screen bg-background">
    <PageHeader />

    <main>
      <!-- Hero -->
      <section class="bg-[#7c2622] py-24 lg:py-32">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">
          <div class="max-w-3xl animate-fade-in">
            <p class="text-white/70 text-sm font-medium tracking-widest uppercase mb-4">
              Established 2008
            </p>

            <h1 class="font-serif text-4xl lg:text-5xl xl:text-6xl font-normal text-white leading-tight mb-6">
              Recognising Excellence in the Souvenir Industry
            </h1>

            <p class="text-lg text-white/80 leading-relaxed mb-8 max-w-2xl">
              The Souvenir Excellence Awards honour retailers, manufacturers,
              and artisans who demonstrate outstanding craftsmanship,
              authenticity, and commitment to preserving cultural heritage
              through souvenirs.
            </p>

            <div class="flex flex-col sm:flex-row gap-4 mb-12">
              <!-- <router-link
                to="/apply"
                class="inline-flex items-center justify-center bg-white text-[#7c2622] px-6 py-3 text-sm font-medium hover:bg-white/90 transition-colors"
              >
                Nominate a Company
              </router-link> -->

              <router-link
                to="/about"
                class="inline-flex items-center justify-center border border-white/30 text-white px-6 py-3 text-sm font-medium hover:bg-white/10 transition-colors"
              >
                Learn More
              </router-link>
            </div>

            <div class="grid grid-cols-3 gap-8 pt-8 border-t border-white/20">
              <div>
                <p class="font-serif text-3xl text-white mb-1">16</p>
                <p class="text-sm text-white/60">Years Running</p>
              </div>
              <div>
                <p class="font-serif text-3xl text-white mb-1">320+</p>
                <p class="text-sm text-white/60">Recipients</p>
              </div>
              <div>
                <p class="font-serif text-3xl text-white mb-1">8</p>
                <p class="text-sm text-white/60">Categories</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Overview -->
      <section class="py-20 lg:py-28 bg-background">
        <div class="mx-auto max-w-6xl px-6 lg:px-8">
          <div class="max-w-2xl mb-16 animate-fade-in">
            <p class="text-sm font-medium tracking-widest uppercase text-muted-foreground mb-4">
              Overview
            </p>

            <h2 class="font-serif text-3xl lg:text-4xl text-foreground mb-4">
              Celebrating Excellence in Souvenirs & Cultural Retail
            </h2>

            <p class="text-muted-foreground leading-relaxed">
              The Souvenir Excellence Awards was established to recognise and
              honour businesses that demonstrate exceptional standards in
              souvenir retail, manufacturing, and artisanal craftsmanship
              across the tourism and cultural heritage sector.
            </p>
          </div>

          <div class="grid md:grid-cols-3 gap-6">
            <router-link
              v-for="(item, i) in highlights"
              :key="item.path"
              :to="item.path"
              class="bg-card border border-border p-8 hover:border-[#7c2622]/40 transition-colors animate-fade-in"
              :style="{ animationDelay: i * 0.1 + 's' }"
            >
              <h3 class="font-serif text-xl text-foreground mb-2">
                {{ item.title }}
              </h3>
              <p class="text-sm text-muted-foreground leading-relaxed">
                {{ item.desc }}
              </p>
              <span class="inline-block mt-4 text-sm font-medium text-[#7c2622]">
                Learn more →
              </span>
            </router-link>
          </div>
        </div>
      </section>
    </main>

    <PageFooter />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import PageFooter from "@/components/PageFooter.vue"

export default {
  name: "Index",
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      highlights: [
        {
          title: "Award Categories",
          desc: "Six categories recognising excellence across the souvenir industry.",
          path: "/categories",
        },
        {
          title: "Judging Process",
          desc: "Rigorous, independent multi-stage evaluation.",
          path: "/judging",
        },
        {
          title: "Past Recipients",
          desc: "Recognised businesses since 2008.",
          path: "/recipients",
        },
      ],
    }
  },
}
</script>